import type {GlobalState} from 'types/store';
import {getUserDisplayName} from 'features/users/selectors/get_user_display_name';
import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';
import type {User} from 'features/users';
import type {Post} from 'mattermost-redux/types/posts';

export const getPostAuthorUserName = (state: GlobalState, post: Post, user?: User, fallbackName?: string) => {
    return getPostOverrideUsername(state, post) || getUserDisplayName(state, user, true, fallbackName);
};
